import { render, staticRenderFns } from "./orderModel.vue?vue&type=template&id=41441fb2&scoped=true"
import script from "./orderModel.vue?vue&type=script&lang=js"
export * from "./orderModel.vue?vue&type=script&lang=js"
import style0 from "./orderModel.vue?vue&type=style&index=0&id=41441fb2&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41441fb2",
  null
  
)

export default component.exports